import React, { memo } from "react";
import PropTypes from 'prop-types';

const ModalCloseIcon = ({ onClick, disabled }) => (
  <div className={`generic-modal-close-icon ${disabled ? 'disabled' : ''}`} onClick={!disabled ? onClick : (e) => e.preventDefault()}>
    <div className="generic-modal-close-icon__container">
      <button className="generic-modal-close-icon__cross" />
    </div>
  </div>
);

ModalCloseIcon.propTypes = {
  //optional
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

ModalCloseIcon.defaultProps = {
  disabled: false
};

export default memo(ModalCloseIcon);
